import { render, staticRenderFns } from "./LabelField.vue?vue&type=template&id=2003fec1&scoped=true"
import script from "./LabelField.vue?vue&type=script&lang=js"
export * from "./LabelField.vue?vue&type=script&lang=js"
import style0 from "./LabelField.vue?vue&type=style&index=0&id=2003fec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2003fec1",
  null
  
)

export default component.exports